import axios from 'axios';
// import { IGlobalSync } from '../../../types';
import FlowyGlobal from '../../flowy-global';

interface IParams {
  fidsToDownload?: string[];
  fidsToRemove?: string[];
  // sync: IGlobalSync;
  global: FlowyGlobal;
}

/**
 * Download projects from the server and save them to the database
 *
 * @param {string[]} fidsToDownload list of project fids to download
 */
async function downloadProjects({
  fidsToDownload,
  fidsToRemove,
  global,
}: IParams) {
  const apiUrl = global.getApiUrl();
  const user = await global.getPlatformInterface()?.getUser();
  const database = global.getDatabase();

  if (user?.credentials && database) {
    const credentials: any = user.credentials;

    if (fidsToDownload === undefined && fidsToRemove === undefined) {
      // If fidsToDownload and fidsToRemove are undefined, we're going to call the ping endpoint
      const pingUrl = `${apiUrl}/main_api/v1/ping/`;

      try {
        const response = await axios.post(
          pingUrl,
          {},
          {
            headers: {
              'Content-Type': 'application/json',
              ...credentials,
            },
          }
        );

        if (response.status === 200) {
          const { projects: projectVersions } = response.data;

          if (
            projectVersions &&
            Array.isArray(projectVersions) &&
            projectVersions.length > 0
          ) {
            const projects = [];
            for (const projectVersion of projectVersions) {
              const projectUrl = `${apiUrl}/main_api/v1/projects/${projectVersion.fid}`;
              const projectResponse = await axios.get(projectUrl, {
                headers: credentials,
              });

              if (projectResponse.status === 200) {
                const { project } = projectResponse.data;
                projects.push(project);
              }
            }

            console.log('pppppppppppprojects: ', projects);

            await database.set({
              type: 'globals',
              value: {
                fid: 'projects',
                data: projects,
              },
            });
          }
        }
      } catch (error) {
        // TODO: handle the ping error
      }
    }
  }
}

export default downloadProjects;
